module.exports = __webpack_public_path__ + "assets/004f76cf01e37aab87959b947477fdb8.png";